import { render, staticRenderFns } from "./AvatarForm.vue?vue&type=template&id=218ecfea&"
import script from "./AvatarForm.vue?vue&type=script&lang=ts&"
export * from "./AvatarForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports